import { h2, paragraph, paragraphCss } from "@/styles/typography";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  margin-bottom: 64px;

  @media screen and (max-width: 992px) {
    margin-bottom: 32px;
  }
`;

const Title = styled(h2)`
  color: ${({ theme }) => theme.colors.softBlack};
  margin-bottom: 40px;

  @media screen and (max-width: 992px) {
    margin-bottom: 18px;
  }
`;

const Contacts = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(400px, 100%), 1fr));
  gap: 32px;

  @media screen and (max-width: 992px) {
    gap: 10px;
  }
`;

const Contact = styled.div`
  display: flex;
  flex-direction: column;
`;

const Name = styled(paragraph)`
  color: ${({ theme }) => theme.colors.tango};
`;

const Position = styled(paragraph)`
  color: ${({ theme }) => theme.colors.softBlack};
`;

const Email = styled.a`
  ${paragraphCss}
  text-decoration: none;
  color: ${({ theme }) => theme.colors.softBlack};
`;

const S = {
  Title,
  Contacts,
  Contact,
  Container,
  Name,
  Position,
  Email,
};

export default S;
